import {
  Button,
  NumericInput,
  SummaryCollapse,
  Tooltip,
  Typography,
} from "@kyan/ui";

import { AccountSelector } from "#/components/AccountSelector/AccountSelector";
import { formatCurrency } from "#/utils/valueFormatters";

import { FormInfo } from "../FormInfo";
import { MarketSelector } from "../MarketSelector";
import { Summary } from "../Summary";
import { useTransferFormController } from "./TransferForm.controller";

export const TransferForm: React.FC = () => {
  const {
    handleTransfer,
    ctaLabel,
    isDisabled,
    tooltip,
    isAmountValid,
    isLoading,
    amount,
    setTransferAmount,
    fromPortfolio,
    setFromPortfolio,
    toPortfolio,
    setToPortfolio,
    fromPortfolioState,
    toPortfolioState,
    account,
    errorMessage,
    finalFromAmount,
    finalToAmount,
  } = useTransferFormController();

  return (
    <div className="flex w-full flex-col items-center">
      <Typography
        element="h2"
        font="grotesk"
        weight="medium"
        variant="primary"
        className="w-full text-left leading-7"
      >
        Transfer
      </Typography>

      <div className="flex w-full flex-col">
        <FormInfo
          title="From"
          info={`Equity ${formatCurrency(fromPortfolioState.equity)}`}
        />

        {account && <AccountSelector account={account} />}

        <MarketSelector
          title="portfolio"
          value={fromPortfolio}
          onChange={setFromPortfolio}
        />

        <NumericInput
          label="Amount"
          value={amount}
          error={errorMessage}
          maxButtonValue={fromPortfolioState.equity}
          onChange={setTransferAmount}
        />

        <FormInfo
          title="To"
          info={`Equity ${formatCurrency(toPortfolioState.equity)}`}
        />

        {account && <AccountSelector account={account} />}

        <MarketSelector
          title="portfolio"
          value={toPortfolio}
          disabledMarket={fromPortfolio}
          onChange={setToPortfolio}
        />

        {isAmountValid && account && !errorMessage && (
          <SummaryCollapse
            title="Summary"
            className="mt-2"
            contentClassName="gap-3 grid"
          >
            <Summary
              account={account}
              market={fromPortfolio}
              amount={finalFromAmount}
            />
            <Summary
              account={account}
              market={toPortfolio}
              amount={finalToAmount}
            />
          </SummaryCollapse>
        )}

        <Tooltip
          avoidCollisions
          side="top"
          align="center"
          className="z-10"
          disabled={!tooltip}
          content={<Typography size={12}>{tooltip}</Typography>}
        >
          <Button
            size="lg"
            className="mt-4"
            disabled={isDisabled}
            isLoading={isLoading}
            onClick={handleTransfer}
          >
            {ctaLabel}
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
